// removed by extract-text-webpack-plugin
module.exports = {"button":"make-order-button__button-3HFWW","normal":"make-order-button__normal-u8mlN blocks__green-2w7kK blocks__medium-2_Kpp blocks__button-1iODk","big":"make-order-button__big--u6bF blocks__green-2w7kK blocks__huge-2XOet blocks__button-1iODk","tooltipWrapper":"make-order-button__tooltipWrapper-gYgq0","tooltip":"make-order-button__tooltip-1WbvB blocks__tooltip-20lA1 blocks__isShown--23z3","tooltipBig":"make-order-button__tooltipBig-2_tXv"};


//////////////////
// WEBPACK FOOTER
// ./components/order/header/make-order-button/make-order-button.css
// module id = 845
// module chunks = 0